import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import React from 'react';
export var appendStylesToDocument = function appendStylesToDocument(cssStylesheets) {
  var cssContent = cssStylesheets.reduce(function (stylesheet, currStyle) {
    return "".concat(stylesheet, "\n").concat(currStyle);
  }, '');
  var style = document.querySelector('style[data-flow-web]');
  if (!style) {
    style = document.createElement('style');
    style.setAttribute('data-flow-web', '');
    document.head.appendChild(style);
  } else {
    cssContent = style.textContent + cssContent;
  }
  style.textContent = cssContent;
};
export function withCss(Component, cssStylesheets) {
  var isStyleInjected = false;
  var WithCss = /*#__PURE__*/function (_React$Component) {
    function WithCss() {
      _classCallCheck(this, WithCss);
      return _callSuper(this, WithCss, arguments);
    }
    _inherits(WithCss, _React$Component);
    return _createClass(WithCss, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!isStyleInjected) {
          appendStylesToDocument(cssStylesheets);
          isStyleInjected = true;
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(Component, this.props);
      }
    }]);
  }(React.Component);
  return WithCss;
}